import { keys } from '../keys';

export const baseUrl = {
  Dashboard: keys().NEXT_PUBLIC_DASHBOARD_URL,
  Marketing: keys().NEXT_PUBLIC_MARKETING_URL,
  Copilot: keys().NEXT_PUBLIC_COPILOT_URL,
  PublicApi: keys().NEXT_PUBLIC_PUBLIC_API_URL,
  MiVenta: keys().NEXT_PUBLIC_MIVENTA_URL
} as const;

export const routes = {
  dashboard: {
    Api: `${baseUrl.Dashboard}/api`,
    auth: {
      changeEmail: {
        Expired: `${baseUrl.Dashboard}/auth/change-email/expired`,
        Index: `${baseUrl.Dashboard}/auth/change-email`,
        Invalid: `${baseUrl.Dashboard}/auth/change-email/invalid`,
        Request: `${baseUrl.Dashboard}/auth/change-email/request`
      },
      Error: `${baseUrl.Dashboard}/auth/error`,
      forgetPassword: {
        Index: `${baseUrl.Dashboard}/auth/forgot-password`,
        Success: `${baseUrl.Dashboard}/auth/forgot-password/success`
      },
      Index: `${baseUrl.Dashboard}/auth`,
      RecoveryCode: `${baseUrl.Dashboard}/auth/recovery-code`,
      resetPassword: {
        Expired: `${baseUrl.Dashboard}/auth/reset-password/expired`,
        Index: `${baseUrl.Dashboard}/auth/reset-password`,
        Request: `${baseUrl.Dashboard}/auth/reset-password/request`,
        Success: `${baseUrl.Dashboard}/auth/reset-password/success`
      },
      SignIn: `${baseUrl.Dashboard}/auth/sign-in`,
      SignUp: `${baseUrl.Dashboard}/auth/sign-up`,
      Totp: `${baseUrl.Dashboard}/auth/totp`,
      verifyEmail: {
        Expired: `${baseUrl.Dashboard}/auth/verify-email/expired`,
        Index: `${baseUrl.Dashboard}/auth/verify-email`,
        Request: `${baseUrl.Dashboard}/auth/verify-email/request`,
        Success: `${baseUrl.Dashboard}/auth/verify-email/success`
      }
    },
    settings: {
      account: {
        Index: `${baseUrl.Dashboard}/settings/account`,
        Notifications: `${baseUrl.Dashboard}/settings/account/notifications`,
        Profile: `${baseUrl.Dashboard}/settings/account/profile`,
        Security: `${baseUrl.Dashboard}/settings/account/security`
      },
      system: {
        Index: `${baseUrl.Dashboard}/settings/system`,
        Health: `${baseUrl.Dashboard}/settings/system/health`,
        Environment: `${baseUrl.Dashboard}/settings/system/environment`,
        AuditLogs: `${baseUrl.Dashboard}/settings/system/audit-logs`,
        EmailLogs: `${baseUrl.Dashboard}/settings/system/email-logs`,
        SignedContracts: `${baseUrl.Dashboard}/settings/system/signed-contracts`,
        RolesPermissions: `${baseUrl.Dashboard}/settings/system/roles-permissions`,
        Roles: `${baseUrl.Dashboard}/settings/system/roles`,
        Permissions: `${baseUrl.Dashboard}/settings/system/permissions`
      },
      Index: `${baseUrl.Dashboard}/settings`
    },
    Index: `${baseUrl.Dashboard}/`,
    invitations: {
      AlreadyAccepted: `${baseUrl.Dashboard}/invitations/already-accepted`,
      Index: `${baseUrl.Dashboard}/invitations`,
      Request: `${baseUrl.Dashboard}/invitations/request`,
      Revoked: `${baseUrl.Dashboard}/invitations/revoked`
    },
    onboarding: {
      Index: `${baseUrl.Dashboard}/onboarding`,
      Organization: `${baseUrl.Dashboard}/onboarding/organization`,
      User: `${baseUrl.Dashboard}/onboarding/user`
    },
    organizations: {
      Index: `${baseUrl.Dashboard}/organizations`,
      slug: {
        ActiveSessions: `${baseUrl.Dashboard}/organizations/[slug]/active-sessions`,
        Agenda: `${baseUrl.Dashboard}/organizations/[slug]/agenda`,
        Analytics: `${baseUrl.Dashboard}/organizations/[slug]/analytics`,
        ChoosePlan: `${baseUrl.Dashboard}/organizations/[slug]/choose-plan`,
        ContactPrefills: `${baseUrl.Dashboard}/organizations/[slug]/contact-prefills`,
        ContactPrefillsView: `${baseUrl.Dashboard}/organizations/[slug]/contact-prefills/[id]`,
        Contacts: `${baseUrl.Dashboard}/organizations/[slug]/contacts`,
        ContactsAdd: `${baseUrl.Dashboard}/organizations/[slug]/contacts/add`,
        ContactsInvite: `${baseUrl.Dashboard}/organizations/[slug]/contacts/invite`,
        Home: `${baseUrl.Dashboard}/organizations/[slug]/home`,
        ProductRequests: `${baseUrl.Dashboard}/organizations/[slug]/product-requests`,
        ProductRequestsView: `${baseUrl.Dashboard}/organizations/[slug]/product-requests/[id]`,
        Contracts: `${baseUrl.Dashboard}/organizations/[slug]/contracts`,
        ContractsView: `${baseUrl.Dashboard}/organizations/[slug]/contracts/[id]`,
        Commissions: `${baseUrl.Dashboard}/organizations/[slug]/commissions`,
        Index: `${baseUrl.Dashboard}/organizations/[slug]`,
        Invitations: `${baseUrl.Dashboard}/organizations/[slug]/invitations`,
        InvitationsView: `${baseUrl.Dashboard}/organizations/[slug]/invitations/[id]`,
        Quotes: `${baseUrl.Dashboard}/organizations/[slug]/quotes`,
        QuotesView: `${baseUrl.Dashboard}/organizations/[slug]/quotes/[id]`,
        QuotesNew: `${baseUrl.Dashboard}/organizations/[slug]/quotes/new`,
        Notifications: `${baseUrl.Dashboard}/organizations/[slug]/notifications`,
        settings: {
          Index: `${baseUrl.Dashboard}/organizations/[slug]/settings`,
          organization: {
            Billing: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/billing`,
            Broadcast: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/broadcast`,
            Developers: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/developers`,
            General: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/general`,
            Index: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization`,
            Members: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/members`,
            Teams: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/teams`,
            TeamDetail: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/teams/[teamId]`,
            Branches: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/branches`,
            Sellers: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/sellers`,
            Products: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/products`,
            ProductDetail: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/products/[productId]`,
            ProductsSync: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/products-sync`,
            ProductTags: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/product-tags`,
            ProductTagDetail: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/product-tags/[tagId]`,
            ProductTagNew: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/product-tags/new`,
            VehicleBrands: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/brands`,
            VehicleBrandDetail: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/brands/[brandId]`,
            VehicleBrandNew: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/brands/new`,
            VehicleModels: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/models`,
            VehicleModelDetail: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/models/[modelId]`,
            VehicleModelNew: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/models/new`,
            VehicleVersions: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/versions`,
            VehicleVersionDetail: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/versions/[versionId]`,
            VehicleVersionNew: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/versions/new`,
            VehicleBrandTags: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/brand-tags`,
            VehicleBrandTagDetail: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/brand-tags/[tagId]`,
            VehicleBrandTagNew: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/brand-tags/new`,
            VehicleModelTags: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/model-tags`,
            VehicleModelTagDetail: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/model-tags/[tagId]`,
            VehicleModelTagNew: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/model-tags/new`,
            VehicleVersionTags: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/version-tags`,
            VehicleVersionTagDetail: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/version-tags/[tagId]`,
            VehicleVersionTagNew: `${baseUrl.Dashboard}/organizations/[slug]/settings/catalog/version-tags/new`
          }
        }
      }
    }
  },
  marketing: {
    Api: `${baseUrl.Marketing}/api`,
    Blog: `${baseUrl.Marketing}/blog`,
    Catalog: `${baseUrl.Marketing}/catalog`,
    Contact: `${baseUrl.Marketing}/contact`,
    CookiePolicy: `${baseUrl.Marketing}/cookie-policy`,
    Index: `${baseUrl.Marketing}/`,
    PrivacyPolicy: `${baseUrl.Marketing}/privacy-policy`,
    Roadmap: 'https://achromatic.canny.io',
    TermsOfUse: `${baseUrl.Marketing}/terms-of-use`
  },
  copilot: {
    Api: `${baseUrl.Copilot}/api`,
    Index: `${baseUrl.Copilot}/`
  },
  miventa: {
    Index: `${baseUrl.MiVenta}/`,
    GetStarted: `${baseUrl.MiVenta}/`
  }
} as const;

type ExtractSlugRoutes<T> =
  T extends Record<string, unknown>
    ? {
        [K in keyof T]: T[K] extends string
          ? T[K] extends `${string}[slug]${string}`
            ? T[K]
            : never
          : ExtractSlugRoutes<T[K]>;
      }[keyof T]
    : never;

type OrganizationsSlugRoutes = ExtractSlugRoutes<
  typeof routes.dashboard.organizations.slug
>;

export function replaceOrgSlug(
  route: OrganizationsSlugRoutes,
  slug: string
): string {
  if (route.indexOf('[slug]') === -1) {
    throw new Error(
      `Invalid route: ${route}. Route must contain the placeholder [slug].`
    );
  }

  return route.replace('[slug]', slug);
}

export function getPathname(route: string, baseUrl: string): string {
  return new URL(route, baseUrl).pathname;
}

export function getOrganizationLogoUrl(
  organizationId: string,
  hash: string
): string {
  return `${routes.dashboard.Api}/organization-logos/${organizationId}?v=${hash}`;
}

export function getUserImageUrl(userId: string, hash: string): string {
  return `${routes.dashboard.Api}/user-images/${userId}?v=${hash}`;
}

export function getContactImageUrl(contactId: string, hash: string): string {
  return `${routes.dashboard.Api}/contact-images/${contactId}?v=${hash}`;
}
